import { styledComponent, Box } from '@hermes/web-components'
import { H3Title, Section as SectionBase } from '../styles'

export const Container = styledComponent(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  padding: '110px 0',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingBottom: 0
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: 0
  }
}))

export const Section = styledComponent(SectionBase)({
  padding: '0 24px',
  maxWidth: '100%',
  position: 'relative',
  alignItems: 'center',
  background:
    'radial-gradient(circle at 0% 95%, rgb(178, 109, 232) -7%, transparent 10%),radial-gradient(circle at 57% 70%, rgb(178, 109, 232) 0%, transparent 35%), rgb(255, 255, 255)'
})

export const Wrapper = styledComponent(Box)(() => ({
  display: 'flex',
  alignItems: 'start',
  flexDirection: 'column',
  gap: '24px'
}))

export const Title = styledComponent(H3Title)(({ theme }) => ({
  fontSize: '36px',
  textAlign: 'start',
  lineHeight: '48px',
  fontWeight: 900,

  [theme.breakpoints.down('md')]: {
    fontSize: '30px',
    lineHeight: '40px',
    fontWeight: 700
  }
}))

export const CoverImageWrapper = styledComponent(Box)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  bottom: 0,
  width: '900px',
  height: '570px',
  [theme.breakpoints.down('xl')]: {
    right: '-320px'
  },
  [theme.breakpoints.down('md')]: {
    position: 'relative',
    height: '350px',
    width: '530px',
    right: '-24px',
    marginLeft: 'auto',
    objectFit: 'cover'
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '50px',
    right: 0
  }
}))
